import { createContext, useContext, useRef, useCallback } from 'react';
import { Socket } from '../Socket/Socket';

const RoomManagerContext = createContext();

export const useRoomManager = () => {
  const context = useContext(RoomManagerContext);
  if (!context) {
    throw new Error('useRoomManager must be used within a RoomManagerProvider');
  }
  return context;
};

export const RoomManagerProvider = ({ children }) => {
  const currentRoomId = useRef(null);
  const isJoined = useRef(false);

  const leaveRoom = useCallback(() => {
    if (currentRoomId.current && isJoined.current) {
      const userId = localStorage.getItem("hoast_user_id");
      if (userId) {
        Socket.emit("left_room", {
          user_id: userId,
          chat_id: currentRoomId.current,
        });
        console.log(`Left room: ${currentRoomId.current}`);
      }
      currentRoomId.current = null;
      isJoined.current = false;
    }
  }, []);

  const joinRoom = useCallback((roomId) => {
    if (roomId && roomId !== currentRoomId.current) {
      if (currentRoomId.current && isJoined.current) {
        leaveRoom();
      }
      
      const userId = localStorage.getItem("hoast_user_id");
      if (userId) {
        Socket.emit("join_room", {
          user_id: userId,
          chat_id: roomId,
        });
        console.log(`Joined room: ${roomId}`);
        currentRoomId.current = roomId;
        isJoined.current = true;
      }
    }
  }, [leaveRoom]);

  const setCurrentRoom = useCallback((roomId) => {
    currentRoomId.current = roomId;
  }, []);

  const setJoinedStatus = useCallback((status) => {
    isJoined.current = status;
  }, []);

  const getCurrentRoom = useCallback(() => {
    return currentRoomId.current;
  }, []);

  const getJoinedStatus = useCallback(() => {
    return isJoined.current;
  }, []);

  const value = {
    leaveRoom,
    joinRoom,
    setCurrentRoom,
    setJoinedStatus,
    getCurrentRoom,
    getJoinedStatus,
  };

  return (
    <RoomManagerContext.Provider value={value}>
      {children}
    </RoomManagerContext.Provider>
  );
};
